import React, { Component, PropTypes } from 'react';
import ClassNames from 'classnames';

export default class GridRow extends Component {
  render() {
    let { className, ...other } = this.props;
    return (
      <div className={ClassNames('row', className)} {...other}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Grid/GridRow.js